module.exports = __webpack_public_path__ + "img/icn_scarpa_edit_1_selezionata.affebf63.png";